import React, { useState } from 'react';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import Popover from '@cloudscape-design/components/popover';
import StatusIndicator from '@cloudscape-design/components/status-indicator';

interface CopyableTextProps {
  text: string;
}

export function CopyableText({ text }: CopyableTextProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Box display="inline-block">
      <span>{text}</span>{' '}
      <Popover
        dismissButton={false}
        position="top"
        size="small"
        triggerType="custom"
        content={
          <StatusIndicator type="success">Copied</StatusIndicator>
        }
        renderWithPortal={true}
      >
        <Button
          iconName={copied ? 'status-positive' : 'copy'}
          variant="inline-icon"
          onClick={handleCopy}
          ariaLabel="Copy to clipboard"
        />
      </Popover>
    </Box>
  );
}
